export const LOCATION_INFO_ACTION_TYPES = {
    GET_LOCATION_INFO_REQUEST: 'GET_LOCATION_INFO_REQUEST',
    UPDATE_LOCATION_INFO: 'UPDATE_LOCATION_INFO',
    UPDATE_PROTECT_PARAMETER: "UPDATE_PROTECT_PARAMETER",
};